/* eslint-disable prettier/prettier */
import { createApp, h } from "vue";
import App from "./App.vue";
import * as BootstrapVueNext from "bootstrap-vue-next";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "@/assets/scss/app.scss";
import "animate.css";
import vClickOutside from "click-outside-vue3";

import { eventBus } from "@/eventBus";

class MyWebComponent extends HTMLElement {
  stream = null;
  mediaRecorder = null;
  audioContext = null;
  isRecording = false; // Track whether recording is active
  audioChunks = [];
  voiceOn = false;
  InitResponse = null;
  current_msg = null;
  startHandler = null;
  assetUrl = process.env.VUE_APP_ASSET_URL;
   _101AGENT_API_URL= `${process.env.VUE_APP_AIAPI_URL}/api/`


  static get observedAttributes() {
    return ["logourl"]; // tell the component to watch this attribute
  }

  attributeChangedCallback(attrName, oldValue, newValue) {
    if (attrName === "logourl" && oldValue !== newValue) {
      eventBus.emit("logourlupdated",newValue);
      // you can also trigger some internal logic here
    }
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" }); // Use Shadow DOM
    console.info(`Plugin asset:${this.assetUrl}`);
    console.info(`Plugin api:${this._101AGENT_API_URL}`);
    let apiToken;
    let userId;
    let userName;
    let lang;
    let mode;
    let autolaunch = false;
    let logourl;
    let forcechat;

    //colors
    let headercolor = "#69afef";
    let bordercolor = "#0285fe";
    let iconcolor = "#0285fe";
    let header_text = "#FFFFFF";

    let cssPosition = {
      position: "fixed",
      top: "auto",
      right: "25px",
      bottom: "25px",
      left: "auto",
      zindex: "1"
    };
    
    this.getToken = () => apiToken; // Provide internal access
    this.setToken = (token) =>{
      apiToken=token;
      localStorage.setItem("apiToken", apiToken);
    }

    this.getUserId = () => userId; // Provide internal access
    this.setUserID = (userid) =>{
      userId = userid;
      localStorage.setItem("userId", userId);
    }

    this.getUserName = () => userName; // Provide internal access
    this.setUserName = (username) =>{
      userName = username;
    } 

    this.getLogoUrl = () => logourl; // Provide internal access
    this.setLogoUrl = (url) =>{
      console.log('seeting',url);
      logourl = url;
    } 

    this.getLang = () => lang;
    this.setLang = (language) =>{
      lang = language;
      if (lang == null) lang = "en";
    }

    this.getColors = () => ({
      headercolor: headercolor,
      bordercolor: bordercolor,
      iconcolor: iconcolor,
      header_text: header_text,
    });
    this.setColors = (headerColor,borderColor,iconColor,headerTextColor) => {
          headercolor = headerColor??headercolor; //if color null keep current color
          bordercolor = borderColor??bordercolor; //if color null keep current color
          iconcolor = iconColor??iconcolor; //if color null keep current color
          header_text = headerTextColor??header_text; //if color null keep current color
    }

    this.getPosition = () => cssPosition;
    this.setPosition = (cssposition) =>{
         cssPosition = cssposition;
    }

    this.getAutolaunch = () => autolaunch;
    this.setAutolaunch = (AutoLaunch) =>{
    autolaunch = AutoLaunch;
    }
    this.getForcechat = () => forcechat;
    this.setForcechat = (ForceChat) =>{
      const strVal = String(ForceChat).toLowerCase();

      forcechat = strVal === "true" || strVal === "1"; // support both "true" and "1"

    }
    
    this.getMode = () => mode;
    this.setMode = (pluginmode) =>{
    mode = pluginmode;
    }
  }
  async loadExternalScript(src) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
  _getAgentMethod(methodName) {
    if (window.agent101api[methodName]) {
      return window.agent101api[methodName];
    } else {
      console.error(`${methodName} function is not available`);
      return null; // Return null or a fallback function
    }
  }
  async InitAgent() {
    const token = this.getToken();
    const mode = this.getMode();
    try {
      const response = await fetch(
        `${this._101AGENT_API_URL}plugin/init-agent`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body:JSON.stringify({
              mode: mode,
            }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error:", error);
    }
  }
  async loadAndInitializeAgent() {
    //initialize agent

    this.InitResponse = await this.InitAgent();
    console.log(this.InitResponse);
    try {
      await this.loadExternalScript(this.InitResponse.script);
      console.log("External script loaded");

      if (window.agent101api) {
        this._onLoad = this._getAgentMethod("_onLoad");
        this._sendMessage = this._getAgentMethod("_sendMessage");
        this._startVoiceCall = this._getAgentMethod("_startVoiceCall");
        this._sendFile = this._getAgentMethod("_sendFile");
        this._endStreaming = this._getAgentMethod("_endStreaming");
      } else {
        console.error("agent101api is not defined.");
      }
    } catch (err) {
      console.error("Failed to load external functions:", err);
    }
  }
   _emitOnLoadOutsideShadow = () => {
      console.log("onload101agent event");
      const event = new CustomEvent("onload101agent", {
        detail: {},
        bubbles: true,
        composed: true, // <-- this is required to escape Shadow DOM
      });
      // Emit on the root element
      document.dispatchEvent(event); // or use $el.dispatchEvent if inside `mounted`
    };
  async connectedCallback() {
    let forcechat = this.getAttribute("forcechat");
    this.setForcechat(forcechat);
    let logourl = this.getAttribute("logourl");
    this.setLogoUrl(logourl);
    let token = this.getAttribute("token");
    this.setToken(token);
    let userid = this.getAttribute("external_userid");
    this.setUserID(userid);
    let username = this.getAttribute("external_username");
    this.setUserName(username);
    let language = this.getAttribute("lang");
    this.setLang(language);
    let pluginmode  = this.getAttribute("mode");
    this.setMode(pluginmode);
    let autolaunchAttr = this.getAttribute("autolaunch");
    try {
      let AutoLaunch = JSON.parse(autolaunchAttr);
      AutoLaunch =AutoLaunch ?? false;
      this.setAutolaunch(AutoLaunch);
    } catch (e) {
      console.error("Invalid autoload JSON:", e);
    }
    let colorAttr = this.getAttribute("colors");
    try {
      const colors = JSON.parse(colorAttr);
      if(colors !=null){
        this.setColors(colors.header,colors.border, colors.icon, colors.header_text);
      }
      // Apply the colors as needed
    } catch (e) {
      console.error("Invalid colors JSON:", e);
    }

    if(pluginmode=="qr"){
        this.setAutolaunch(true);
    }
     if(pluginmode=="sound"){
        this.setAutolaunch(true);
    }
    //position
    let csspositionAttr = this.getAttribute("cssposition");
    try {
      let pos=JSON.parse(csspositionAttr);
      if(pos!=null)
        this.setPosition(pos);
    }catch (e) {
      console.error("Invalid position:", e)
    }

    // Load external JS file and override methods
    await this.loadAndInitializeAgent();
    
    await this._onLoad(
      this.InitResponse,
      this.getUserId(),
      this.getUserName(),
      eventBus,
      pluginmode
    );
    if(pluginmode=='sound')
        localStorage.setItem(
          "agent101activevoicemode",
          JSON.stringify(true)
        );
    this._emitOnLoadOutsideShadow();
    localStorage.setItem("call_start", new Date().getTime());

    eventBus.on("sendTextMessage", (message) => {
      if (this.InitResponse.no_budget==true){
        console.error('Oops no budget.');
        return;
      }
      this._sendMessage(message.trim());
    });
    this.startHandler =async () => {
      if (this.InitResponse.no_budget==true){
        console.error('No budget.');
        return;
      }
      localStorage.setItem("call_start", new Date().getTime());
      this.voiceOn = true;
      this._startVoiceCall();
    }
    eventBus.on("startVoiceCall",this.startHandler);

    eventBus.on("endVoiceCall", async () => {
      if (this.InitResponse.no_budget==true){
        console.error('Sorry no budget.');
        return;
      }
      console.log("ending voice call");
      this.voiceOn = false;
      await this._endStreaming((current_call_url, datetime) => {
        eventBus.emit("callDone", current_call_url, datetime);
      });
    });

    eventBus.on("sendFile", async (object) => {
      this._sendFile(object);
    });

    if (!this.vueMounted) {
      this.vueMounted = true;

      // Create a container for Vue inside Shadow DOM
      const root = document.createElement("div");
      this.shadowRoot.appendChild(root);

      // Inject external styles and wait for them to load
      await this.loadStyles([
        `${this.assetUrl}/app.101agentplugin.css`,
      ]);

      // Create a Vue instance
      const app = createApp({
        render: () => h(App),
      });

      app.provide('params', {
        autolaunch:this.getAutolaunch(),
        forcechat:this.getForcechat(),
        mode: this.getMode(),
        no_budget: this.InitResponse.no_budget
      });

      // Register BootstrapVueNext components manually
      Object.keys(BootstrapVueNext).forEach((key) => {
        if (typeof BootstrapVueNext[key] === "object") {
          app.component(key, BootstrapVueNext[key]);
        }
      });
      app.use(vClickOutside);
      // Mount Vue inside Shadow DOM
      app.mount(root);
      eventBus.emit("setUser", this.getUserName());
      eventBus.emit("initAgent", this.InitResponse);
      eventBus.emit("setLang", this.getLang());
      eventBus.emit("setColors", this.getColors());
      eventBus.emit("setPosition", this.getPosition());
      eventBus.emit("logourlupdated", this.getLogoUrl())
    }
  }
async disconnectedCallback() {

    console.log('DISCONNECTED DETECTED');
    this.stopCall();

    setTimeout(()=>{
       eventBus.off("startVoiceCall",this.startHandler);
    },500);
}
  async loadStyles(urls) {
    const loadPromises = urls.map((url) => {
      return new Promise((resolve, reject) => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = url;
        link.onload = resolve;
        link.onerror = reject;
        this.shadowRoot.appendChild(link);
      });
    });

    // Wait for all styles to be loaded
    await Promise.all(loadPromises);
  }
  stopCall(){
    console.info('Manual call stop.');
    eventBus.emit("websocketHangup");
  }
}

// Register Web Component globally
customElements.define("chat-101-agent", MyWebComponent);
